module.exports = __webpack_public_path__ + "img/valenciaplaza.6085020d.svg";